import React from 'react';
import MainLayout from '@/layouts/MainLayout/MainLayout.tsx';
import routes from '@/constants/routes.ts';
import styles from './Error403.module.scss';
import { useNavigate } from 'react-router';
import Button from '@/components/ui/Button/Button.tsx';

const Error403: React.FC = () => {
	const navigate = useNavigate();

	return (
		<MainLayout>
			<div className={styles.wrapper}>
				<h1>You do not have access to this page or resource</h1>
				<Button
					size="large"
					color="green"
					align="center"
					borderRadius="large"
					onClick={() => navigate(routes.myClimate)}
				>
					Go to Dashboard
				</Button>
			</div>
		</MainLayout>
	);
};

export default Error403;
